import request from '@/utils/infrastructure/communication/request';

export async function queryEditActive(id) {
  return request.post(`/process/activate/${id}`, {});
}

export async function updateFavorite({ id, isFavorite }) {
  const method = isFavorite ? 'delete' : 'post';
  return request[method](`/process/favorites/${id}`, {});
}
